export default "__VITE_ASSET__oTiH$$7y__"